import { SettingGroupType } from "../models/SettingGroupType";

import { useAppDispatch, useAppSelector } from "../hooks/redux";
import { closeAlert } from "../features/session";

import { Container, Stack, Alert } from "@mui/material";

const SystemNotifications: React.FC = () => {
    const dispatch = useAppDispatch();

    const session = useAppSelector((state) => state.session);

    const alerts = useAppSelector((state) =>
        state.systemConfigs[SettingGroupType.frontOfficeNotifications]?.filter(
            (alert) =>
                alert.name.startsWith("pl_start_page_msg_text") &&
                alert.value &&
                !session.closedAlerts.includes(alert.name)
        )
    );

    if (!alerts || alerts.length === 0) return null;

    return (
        <Container>
            <Stack
                spacing={2}
                sx={{
                    paddingTop: 2,
                }}
            >
                {alerts.map((alert) => (
                    <Alert
                        key={alert.key}
                        variant="outlined"
                        severity="warning"
                        onClose={() => {
                            dispatch(closeAlert(alert.name));
                        }}
                    >
                        {alert.value}
                    </Alert>
                ))}
            </Stack>
        </Container>
    );
};

export default SystemNotifications;
